export const doSMS = async (phoneNumber, pin, brand = "Ecosystem") => {
  try {
    let response = await fetch(
      `https://apricot-mole-2227.twil.io/sms?phoneNumber=${phoneNumber}&pin=${pin}&brand=${brand}`,
      {
        method: "GET",
      }
    );
    let res = await response.json();
    return res;
  } catch (err) {
    return err;
  }
};

export const inviteUserSMS = async (phoneNumber, brand, firstName, bespokeUrl) => {
  try {
    let response = await fetch(
      `https://apricot-mole-2227.twil.io/invite-to-community?phoneNumber=${phoneNumber}&brand=${brand}&firstName=${firstName}&bespokeUrl=${bespokeUrl}`,
      {
        method: "GET",
      }
    );
    let res = await response.json();
    return res;
  } catch (err) {
    return err;
  }
};

export const sendInvitation = async (phoneNumber, username, property_name) => {
  try {
    let response = await fetch(
      `https://apricot-mole-2227.twil.io/landlord_invite?phoneNumber=${phoneNumber}&username=${username}&property_name=${property_name}`,
      {
        method: "GET",
      }
    );
    let res = await response.json();
    return res;
  } catch (err) {
    return err;
  }
};

export const alertAppointment = async (
  phoneNumber,
  brand,
  firstName,
  dateString
) => {
  try {
    let response = await fetch(
      `https://apricot-mole-2227.twil.io/alert-appointment?phoneNumber=${phoneNumber}&brand=${brand}&firstName=${firstName}&dateString=${dateString}`,
      {
        method: "GET",
      }
    );
    let res = await response.json();
    return res;
  } catch (err) {
    return err;
  }
};



// WEBPACK FOOTER //
// ./src/functions/Twilio.js